"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorGlassAndRepairExcessWordingGenerator = void 0;
var React = require("react");
var AnnualMotorGlassAndRepairExcessWordingGenerator = exports.AnnualMotorGlassAndRepairExcessWordingGenerator = /** @class */ (function () {
    function AnnualMotorGlassAndRepairExcessWordingGenerator() {
    }
    AnnualMotorGlassAndRepairExcessWordingGenerator.getGlassAndRepairExcessWording = function (vehicle) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "glass-repair" },
                React.createElement("div", { className: "font-weight-semi-bold" }, "Glass-only excess costs you less"),
                React.createElement("div", { className: "detail-key" }, "Glass repair excess:"),
                React.createElement("div", { className: "detail-value" },
                    "just ",
                    React.createElement("span", { className: "font-weight-bold" }, "\u00A3".concat(vehicle.annualVehicleExcess.windscreenRepairExcess, " ")))),
            React.createElement("div", { className: "glass-replacement mb-0 pb-0" },
                React.createElement("div", { className: "detail-key" }, "Glass replacement excess:"),
                React.createElement("div", { className: "detail-value" },
                    "just ",
                    React.createElement("span", { className: "font-weight-bold" }, "\u00A3".concat(vehicle.annualVehicleExcess.windscreenReplacementExcess, " ")))),
            React.createElement("div", { className: "non-recommended-excess mt-4" },
                React.createElement("div", { className: "font-weight-semi-bold" }, "Non-recommended repairer excess costs you more"),
                React.createElement("div", { className: "detail-key" }, "Non-recommended repairer excess:"),
                React.createElement("div", { className: "detail-value" },
                    React.createElement("span", { className: "font-weight-bold" }, "\u00A3".concat(vehicle.annualVehicleExcess.nonRecommendedRepairerExcess)))),
            React.createElement("div", { className: "grid-col-2 mt-0" },
                "This is in addition to the excesses shown above if you choose a garage ",
                React.createElement("span", { className: "font-weight-bold" }, "not"),
                " on our list of recommended repairers.",
                React.createElement("br", null),
                "This also applies to glass replacement but ",
                React.createElement("span", { className: "font-weight-semi-bold" }, "not"),
                " glass-only repairs.")));
    };
    return AnnualMotorGlassAndRepairExcessWordingGenerator;
}());
//# sourceMappingURL=AnnualMotorGlassAndRepairExcessWordingGenerator.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/annual/motor/AnnualMotorGlassAndRepairExcessWordingGenerator.js
// module id = 298
// module chunks = 0